// NPM packages
import React from "react";
import ReactDOM from "react-dom";

// Project files
import App from "./App";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
